var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"1250px","scrollable":"","persistent":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('mf-button',{attrs:{"outlined":"","color":"marca-0-l10","label":_vm.hasProduct ? 'Alterar Produto' : 'Selecionar Produto'},on:{"click":function($event){_vm.dialog = true}}})]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('gerenciamento-produto-tabela',{ref:"produtoTabela",attrs:{"isSelect":"","height":"300"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),_c('v-card-actions',{staticClass:"px-6"},[_c('mf-action-buttons',{attrs:{"primary-button":{
          text: 'Confirmar',
          action: _vm.confirmSelectedProduct,
          isVisible: true,
          isDisabled: Object.keys(_vm.selected).length === 0,
        },"secondary-button":{
          text: 'Cancelar',
          action: _vm.closeDialog,
          isVisible: true,
        }}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }